import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToInstance } from 'class-transformer';
import { map, Observable, switchMap, takeLast, tap } from 'rxjs';
import {
	DefaultErrorMessage,
	mapResponse,
} from 'src/lib/utilities/api/map-response';
import {
	FileDirectUploadArgument,
	FileDirectUploadModel,
} from './file-direct-upload.model';

@Injectable({
	providedIn: 'root',
})
export class FileDirectUploadService {
	constructor(private httpClient: HttpClient) {}

	private getFileUploadUrl = (
		uid: number,
		args: FileDirectUploadArgument,
	): Observable<FileDirectUploadModel> => {
		return this.httpClient
			.post<unknown>(`/api/v1/students/${uid}/direct-file-upload`, args)
			.pipe(
				mapResponse((r) => plainToInstance(FileDirectUploadModel, r), {
					errorCode: '77F87EC8',
					errorMessage: DefaultErrorMessage.Saving,
				}),
			);
	};

	private awsPut = (
		link: string,
		file: File,
		item: FileDirectUploadModel,
	): Observable<FileDirectUploadModel> => {
		const headers = new HttpHeaders({
			'Content-Type': file.type,
		});

		return this.httpClient.put(link, file, { headers: headers }).pipe(
			takeLast(1),
			mapResponse((r) => r, {
				errorCode: '83C7B64C',
				errorMessage: 'File upload failed',
			}),
			map(() => item), // Return the item after the upload is successful
		);
	};

	public processFileUpload = (
		uid: number,
		file: File,
		args: FileDirectUploadArgument,
	): Observable<FileDirectUploadModel> => {
		const startTime = Date.now();

		return this.getFileUploadUrl(uid, args).pipe(
			switchMap((r) => {
				return this.awsPut(r.upload_url, file, r).pipe(
					tap({
						error: (err) => {
							try {
								this.httpClient
									.post<null>(`/api/v1/log-store/direct-file-upload`, {
										message: 'AWS file upload error',
										log: {
											uid: uid,
											upload_args: args,
											aws_args: r,
											seconds_elapsed: (Date.now() - startTime) / 1000,
											error: err.message,
										},
									})
									.subscribe();
							} catch (e) {
								console.error('Error logging AWS file upload error:', e);
							}
						},
					}),
				);
			}),
		);
	};
}
